import type { argusAuthPlugin } from '@argus-labs/auth-backend/src/auth-plugin'
import type { BetterAuthClientPlugin } from 'better-auth/client'
import { anonymousClient, emailOTPClient, oneTimeTokenClient } from 'better-auth/client/plugins'
import { createAuthClient } from 'better-auth/react'

export const authClient = createAuthClient({
  basePath: '/auth',
  plugins: [
    anonymousClient(),
    emailOTPClient(),
    oneTimeTokenClient(),
    {
      id: 'argus-auth',
      $InferServerPlugin: {} as ReturnType<typeof argusAuthPlugin>,
    } satisfies BetterAuthClientPlugin,
  ],
})
